import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../shared/components/buttons';
import classes from './TitleRow.module.scss';
import { preRegisteredStore } from '../../../../stores/preRegisteredStore';
import {
  PRE_REGISTERED_COLUMN,
  PreRegisteredColumn,
} from '../PreRegisteredTable.settings';

type TitleRowProps = {
  visibleColumns: PreRegisteredColumn[];
};

const TitleRow = observer(({ visibleColumns }: TitleRowProps) => {
  const { handleSort, getIsSortedBy } = preRegisteredStore.filterMethods;

  const renderColumnsInfo: Record<PreRegisteredColumn, ReactElement> = {
    [PRE_REGISTERED_COLUMN.NAME]: (
      <GridTableCell>
        <SortButtons
          fieldName="CUSTOMER_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Name
        </SortButtons>
      </GridTableCell>
    ),
    [PRE_REGISTERED_COLUMN.COACH]: (
      <GridTableCell>
        <SortButtons
          fieldName="COACH_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Coach
        </SortButtons>
      </GridTableCell>
    ),
    [PRE_REGISTERED_COLUMN.DATE_OF_UPDATE]: (
      <GridTableCell justify="end">Date of Update</GridTableCell>
    ),
  };

  return (
    <GridTableRow variant="unstyled" className={classes.titleRow}>
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { TitleRow };
